module.exports = __webpack_public_path__ + "img/ippy-logo.c1081b2.svg";